import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LangInterceptor implements HttpInterceptor {
  constructor(private translate: TranslateService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentLang = this.translate.currentLang || this.translate.getDefaultLang() || 'pt';

    if (req.url.startsWith('/api') || req.url.startsWith('/auth')) {
      req = req.clone({
        setHeaders: { 
          'UserCurrentLanguage': currentLang
        }
      });
    }

    return next.handle(req);
  }
}